/**
 * (c) 2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
const fontSizes = {
  xs: "0.75rem",
  sm: "0.875rem",
  md: "0.9rem",
  lg: "1.012rem",
  xl: "1.125rem",
  "2xl": "1.35rem",
  "3xl": "1.687rem",
  "4xl": "2.025rem",
  "5xl": "2.7rem",
  "6xl": "3.375rem",
  "7xl": "4.05rem",
  "8xl": "5.4rem",
  "9xl": "7.2rem",
};

export default fontSizes;
